export default "__VITE_ASSET__C8I6jpeq__"